import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import styles from './OfflineBanner.module.css';

// WHY: the persistent offline-state indicator (nano-adoption #1; pattern-error-handling.md §6). This
// banner is the connectivity live region (role="status" aria-live) and owns the "you're offline"
// announcement; the transient "back online" confirmation stays a sonner toast (useAppInitialization).
// CONSTRAINT: do NOT also toast on going offline — that would double-announce the same state change.
// Rendered app-wide (App.tsx) so desktop and mobile share one signal; pointer-events:none so the thin
// top strip never intercepts taps on the content beneath.
export function OfflineBanner() {
  const { isOnline } = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite" aria-atomic="true">
      <WifiOff size={16} aria-hidden="true" />
      <span>You&rsquo;re offline. Some features may not work.</span>
    </div>
  );
}
